export const enum EntryEvent {
    Update = 'reservation_update',
}

export interface UpdateEventData {
    id: string;
    updateData?: any;
}
